'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseState = exports.parseHash = exports.parseParams = undefined;

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('utils/OAuthUtils');

var parseParams = exports.parseParams = function parseParams(paramsString) {
  if (!paramsString) {
    return {};
  }

  var parsed = {};
  var keyValues = paramsString.split('&');
  for (var i = 0; i < keyValues.length; i++) {
    var keyValue = keyValues[i];
    var splitKeyValue = keyValue.split('=');
    try {
      parsed[decodeURIComponent(splitKeyValue[0])] = decodeURIComponent(splitKeyValue[1]);
    } catch (error) {
      LOG.error('Error: Unable to parse params', {
        extra: {
          keyValue: keyValue,
          error: error
        }
      });
    }
  }
  return parsed;
};

var parseHash = exports.parseHash = function parseHash(hash) {
  if (!hash) {
    return {};
  }

  var params = hash.split('#')[1] || '';
  return parseParams(params);
};

var parseState = exports.parseState = function parseState(hash) {
  var _parseHash = parseHash(hash),
      state = _parseHash.state;

  try {
    if (state) {
      return JSON.parse(state);
    }
  } catch (error) {
    LOG.error('Error parsing oauth state', {
      extra: {
        error: error
      }
    });
  }

  return {};
};